import { useContext } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Flex,
  Text,
  Box,
  ViewerContext,
  Avatar,
  localStorage,
  DropDown,
} from 'dash-ui';

import { useLogoutMutation } from 'gql/generated.graphql';
import { RoutesPath } from 'flow-components/routes/routes';

const AnchorContainer = styled(Flex)`
  height: inherit;
`;
const AvatarContainer = styled(Box)<{ isOpen: boolean }>`
  border-radius: 50%;
  border: 1px solid
    ${({ isOpen, theme }) => (isOpen ? theme.colors.b50 : 'transparent')};
`;

function ProfileDropdown() {
  const { account } = useContext(ViewerContext);
  const { t } = useTranslation('common', { keyPrefix: 'labels' });
  const { setAccount, setTokens } = useContext(ViewerContext);
  const navigate = useNavigate();

  const [logout, { loading }] = useLogoutMutation();
  const onLogoutButtonClick = async () => {
    // log out on backend
    await logout();
    // log out on storage
    localStorage.setAccessToken('');
    localStorage.setRefreshToken('');
    localStorage.setRefreshTokenExpiry('');
    // log out on context
    if (setAccount && setTokens) {
      setTokens({});
      setAccount(null);
    }
  };

  const onAccountButtonClick = () => {
    navigate(RoutesPath.Account);
  };

  return (
    <Box mr={[4, 4, 14, 14]} data-testid="profile">
      <DropDown
        Anchor={({ isOpen }: { isOpen: boolean }) => (
          <AnchorContainer alignItems="center">
            <Flex>
              <Text>{account?.email}</Text>
            </Flex>
            <Flex ml={4}>
              <AvatarContainer isOpen={isOpen}>
                <Avatar />
              </AvatarContainer>
            </Flex>
          </AnchorContainer>
        )}
        items={[
          {
            key: 'account',
            icon: 'account',
            children: t`account`,
            iconProps: { size: 16 },
            onClick: onAccountButtonClick,
          },
          {
            key: 'logout',
            icon: 'logout',
            iconProps: { size: 22 },
            children: t`signOut`,
            onClick: onLogoutButtonClick,
            disabled: loading,
            isLoading: loading,
          },
        ]}
      />
    </Box>
  );
}

export default ProfileDropdown;
